// source: auth/token.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.auth.Token', null, global);
goog.exportSymbol('proto.auth.Token.TokenCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.auth.Token = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.auth.Token.oneofGroups_);
};
goog.inherits(proto.auth.Token, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.auth.Token.displayName = 'proto.auth.Token';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.auth.Token.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.auth.Token.TokenCase = {
  TOKEN_NOT_SET: 0,
  COGNITOJWT: 1,
  FIREBASEIDTOKEN: 2,
  APIKEY: 3
};

/**
 * @return {proto.auth.Token.TokenCase}
 */
proto.auth.Token.prototype.getTokenCase = function() {
  return /** @type {proto.auth.Token.TokenCase} */(jspb.Message.computeOneofCase(this, proto.auth.Token.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.auth.Token.prototype.toObject = function(opt_includeInstance) {
  return proto.auth.Token.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.auth.Token} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auth.Token.toObject = function(includeInstance, msg) {
  var f, obj = {
    cognitojwt: jspb.Message.getFieldWithDefault(msg, 1, ""),
    firebaseidtoken: jspb.Message.getFieldWithDefault(msg, 2, ""),
    apikey: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.auth.Token}
 */
proto.auth.Token.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.auth.Token;
  return proto.auth.Token.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.auth.Token} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.auth.Token}
 */
proto.auth.Token.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCognitojwt(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirebaseidtoken(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setApikey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.auth.Token.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.auth.Token.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.auth.Token} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.auth.Token.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string CognitoJWT = 1;
 * @return {string}
 */
proto.auth.Token.prototype.getCognitojwt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.auth.Token} returns this
 */
proto.auth.Token.prototype.setCognitojwt = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.auth.Token.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.auth.Token} returns this
 */
proto.auth.Token.prototype.clearCognitojwt = function() {
  return jspb.Message.setOneofField(this, 1, proto.auth.Token.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auth.Token.prototype.hasCognitojwt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string FirebaseIDToken = 2;
 * @return {string}
 */
proto.auth.Token.prototype.getFirebaseidtoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.auth.Token} returns this
 */
proto.auth.Token.prototype.setFirebaseidtoken = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.auth.Token.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.auth.Token} returns this
 */
proto.auth.Token.prototype.clearFirebaseidtoken = function() {
  return jspb.Message.setOneofField(this, 2, proto.auth.Token.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auth.Token.prototype.hasFirebaseidtoken = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string APIKey = 3;
 * @return {string}
 */
proto.auth.Token.prototype.getApikey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.auth.Token} returns this
 */
proto.auth.Token.prototype.setApikey = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.auth.Token.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.auth.Token} returns this
 */
proto.auth.Token.prototype.clearApikey = function() {
  return jspb.Message.setOneofField(this, 3, proto.auth.Token.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.auth.Token.prototype.hasApikey = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.auth);
